import React from 'react';
import TimelineSection from './WebsiteTimelineSection';
import { renderBasicSectionContent } from './WebsiteBasicSections';

export function renderSectionContent({
  section,
  theme,
  css,
  viewportWidth,
  mode,
  isMobile,
  onWeddingGalleryPhotoUpload,
  onBestMenAndMaidsPhotoUpload,
}) {
  if (section.type === 'timeline') {
    return (
      <TimelineSection
        section={section}
        theme={theme}
        css={css}
        viewportWidth={viewportWidth}
        isMobile={isMobile}
        mode={mode}
      />
    );
  }

  return renderBasicSectionContent({
    section,
    theme,
    css,
    viewportWidth,
    mode,
    onWeddingGalleryPhotoUpload,
    onBestMenAndMaidsPhotoUpload,
  });
}
